var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_210_4366",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 18.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_210_4366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.10449 15.4166L9.24954 3.08325L16.3946 15.4166H2.10449ZM3.42975 14.6458H15.0693L9.24954 4.62492L3.42975 14.6458ZM9.24954 13.5785C9.38392 13.5785 9.49659 13.5331 9.58755 13.4421C9.67851 13.3511 9.72399 13.2385 9.72399 13.1041C9.72399 12.9697 9.67851 12.857 9.58755 12.7661C9.49659 12.6751 9.38392 12.6296 9.24954 12.6296C9.11516 12.6296 9.00249 12.6751 8.91153 12.7661C8.82057 12.857 8.77509 12.9697 8.77509 13.1041C8.77509 13.2385 8.82057 13.3511 8.91153 13.4421C9.00249 13.5331 9.11516 13.5785 9.24954 13.5785ZM8.86412 11.8588H9.63496V8.00464H8.86412V11.8588Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDash);
export default __webpack_public_path__ + "static/media/warning_dash.1093036b417a149c2a01e85e35e646cb.svg";
export { ForwardRef as ReactComponent };